import { render, staticRenderFns } from "./StudioHomeTemplateClassic.vue?vue&type=template&id=bbbfd3c2&scoped=true&"
import script from "./StudioHomeTemplateClassic.vue?vue&type=script&lang=js&"
export * from "./StudioHomeTemplateClassic.vue?vue&type=script&lang=js&"
import style0 from "./StudioHomeTemplateClassic.vue?vue&type=style&index=0&id=bbbfd3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbfd3c2",
  null
  
)

export default component.exports